import React from "react";
import { GoogleMap } from "@react-google-maps/api";
import { useCallback } from "react";
import { useMapContext } from "./MapContext";
import styles from "../data/style.json";

const containerStyle = {
  width: "100%",
  height: "100%",
};

export default function Map({ center, children }) {
  const { setMap, isLoaded, handleBoundsChanged } = useMapContext();

  const onLoad = useCallback(function callback(map) {
    new window.google.maps.LatLngBounds(center);
    map.zoom = 7;
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback() {
    setMap(null);
  }, []);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={7}
      onLoad={onLoad}
      onUnmount={onUnmount}
      onBoundsChanged={handleBoundsChanged}
      options={{
        streetViewControl: false,
        styles,
        fullScreenControl: false,
        mapTypeControlOptions: {
          mapTypeIds: [
            window.google.maps.MapTypeId.ROADMAP,
            window.google.maps.MapTypeId.SATELLITE,
          ],
        },
      }}
    >
      {children}
    </GoogleMap>
  ) : (
    <></>
  );
}
